import { render, staticRenderFns } from "./AmountOrderDiscountChart.vue?vue&type=template&id=139db868&scoped=true&"
import script from "./AmountOrderDiscountChart.vue?vue&type=script&lang=js&"
export * from "./AmountOrderDiscountChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139db868",
  null
  
)

export default component.exports